import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import { icons } from '@shared/static/icons';
import { ThemeButton } from '@shared/ui/buttons';
import { CountryFlag, CounterIcon } from '@shared/ui/parts';
import { useTransferDialog, useCreateCardDialog } from '@utils/dialogs-hooks';
import { currencySymbols, binsLogo } from '@utils/static';
import { formatBalanceUi } from '@utils/balance-helpers';
import { theme } from '@utils/libs/theme';
import { getTotalCards } from '@utils/helpers';

export default function DashboardCards() {
  const { t } = useTranslation();
  const { openTransferDialog } = useTransferDialog();
  const { openCreateCardDialog } = useCreateCardDialog();
  const { bankWallets } = useSelector((state) => state.bankWallets);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className="dashboardCards__wrap custom-scrollbar">
      <div className="dashboardCards">
        {bankWallets
          ?.filter((item) => item.bin)
          .map((item) => (
            <div className="dashboardCards__item" key={item.bank_id}>
              <div className="select-bank-item">
                <CountryFlag countryCode={binsLogo[item.bank_id]} />
                <div>
                  <p className="fw-500">{item.bank_public_name}</p>
                  <p className="secondary-text">BIN {item.bin}</p>
                </div>
                <div className="select-bank-payment">
                  <CounterIcon
                    icon="card-input"
                    value={getTotalCards(item)}
                    hasBg
                  />
                  {icons[item.card_type]}
                  <p className="select-bank-symbol">
                    {currencySymbols[item.currency]}
                  </p>
                </div>
              </div>
              <p
                className="title-h2r t-right"
                dangerouslySetInnerHTML={{
                  __html: formatBalanceUi(
                    item.balance,
                    item.currency,
                    null,
                    true,
                  ),
                }}
              />
              <div className="dashboardCards__bottom">
                <ThemeButton
                  minWidth
                  appearance={isMobile ? 'primary' : 'secondary'}
                  startIcon="add"
                  onClick={() => openCreateCardDialog(item)}
                >
                  {t('create_card')}
                </ThemeButton>
                <ThemeButton
                  minWidth
                  appearance="secondary"
                  startIcon="transfer"
                  onClick={() => openTransferDialog(item)}
                >
                  {t('top_up_bin')}
                </ThemeButton>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
